import { Injectable } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { IDateFieldSpecs, IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IComboboxOption } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.component";
import { INumberFieldSpecs } from "libraries/module/formbuilder/fields/number/INumberFieldSpecs";
import { EnumsResourceService } from "libraries/service/booking/enums/enums-resource.service";
import { Observable, of } from "rxjs";
import { flatMap } from "rxjs/internal/operators";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";

export enum ETicketSearchParts {
    action = 'action',
    freeSearch = 'freeSearch',
    booking = 'booking',
    ticket = 'ticket',
}

@Injectable()
export class SearchFormHelperService {

    constructor(
        private readonly enumsResourceService: EnumsResourceService
    ) {
    }

    public getHosts(): Observable<IComboboxOption[]> {
        return this.enumsResourceService
            .listSystems()
            .pipe(
                flatMap((hostAlias: {codes: string[], aliases: string[]}): Observable<IComboboxOption[]> => {
                    return of(
                        hostAlias.codes.map((value: string, index: number): IComboboxOption => {
                            return {
                                value,
                                label: hostAlias.aliases[index],
                            };
                        })
                    );
                })
            );
    }

    public createSimpleConfig(name: string, formGroup: FormGroup, label: string, description?: IDescriptionLabels): IFieldSpecs {
        return {
            formGroup,
            formControlName: name,
            label,
            description,
        };
    }

    public createDateConfig(name: string, formGroup: FormGroup, label: string, isMaxToday: boolean = true, description?: IDescriptionLabels): IDateFieldSpecs {
        return {
            formGroup,
            formControlName: name,
            maxDate: isMaxToday ? new Date(): null,
            label,
            description
        };
    }

    public createNumberConfig(name: string, formGroup: FormGroup, label: string, description?: IDescriptionLabels): INumberFieldSpecs {
        return {
            formGroup,
            formControlName: name,
            step: 50,
            min: 0,
            unit: "€",
            label,
            description
        };
    }
}
